const NAME = "MY_SCHEDULE";

export default NAME;
